import config from '../config';
import http from '../utils/http';
import axios from 'axios';
import * as Cookies from 'js-cookie';
const { api } = config;

/**
 * Update profile.
 *
 * @return {Object}
 */
export async function updateProfile(userId, data) {
    const url = `${api.endpoints.users}/${userId}`;

    const response = await http.put(url, data);

    return response;
}

/**
 * Update profile.
 *
 * @return {Object}
 */
export async function uploadImage(formData) {
    const cssToken = Cookies.get('csst');
    if (cssToken) {
        try {
            const response = await axios.post(api.endpoints.upload, formData, {
                headers: {
                    Authorization: `Bearer ${cssToken}`
                },
                withCredentials: true
            });

            return response;
        } catch (e) {
            throw e;
        }
    }
}
